import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconLoading48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="list">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.00013 6.00001L6.00127 6.00006L6.00122 8.00006L4.00008 8.00001L4.00013 6.00001Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00005 6.0001L44 6.00098L44 8.00098L8 8.0001L8.00005 6.0001Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.00013 17L6.00127 17.0001L6.00122 19.0001L4.00008 19L4.00013 17Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00005 17.0001L44 17.001L44 19.001L8 19.0001L8.00005 17.0001Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.00013 28L6.00127 28.0001L6.00122 30.0001L4.00008 30L4.00013 28Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.00013 39L6.00127 39.0001L6.00122 41.0001L4.00008 41L4.00013 39Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00005 28.0001L44 28.001L44 30.001L8 30.0001L8.00005 28.0001Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00005 39.0001L44 39.001L44 41.001L8 41.0001L8.00005 39.0001Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconList24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="list">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.00005 8.00002L3.00005 8.00006L3 9.99957L1 9.99953L1.00005 8.00002Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.00811 8.00001L23.0081 8.00043L23.0081 9.99994L5.00806 9.99952L5.00811 8.00001Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.00005 14L3.00005 14.0001L3 15.9996L1 15.9995L1.00005 14Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.00811 14L23.0081 14.0004L23.0081 15.9999L5.00806 15.9995L5.00811 14Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.00005 20L3.00005 20.0001L3 21.9996L1 21.9995L1.00005 20Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.00811 20L23.0081 20.0004L23.0081 21.9999L5.00806 21.9995L5.00811 20Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.00005 1.99999L3.00005 2.00003L3 3.99954L1 3.9995L1.00005 1.99999Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.00811 1.99998L23.0081 2.0004L23.0081 3.99991L5.00806 3.99949L5.00811 1.99998Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconList16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="list">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.00005 1.0001L16 1.0004L16 3.0004L4 3.0001L4.00005 1.0001Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.00005 7.00001L16 7.00031L16 9.00031L4 9.00001L4.00005 7.00001Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.00005 13L16 13.0003L16 15.0003L4 15L4.00005 13Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.16621e-05 1.0001L1.9998 1.00015L1.99976 3.00015L-3.73125e-05 3.0001L1.16621e-05 1.0001Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.16621e-05 7.00001L1.9998 7.00006L1.99976 9.00006L-3.73125e-05 9.00001L1.16621e-05 7.00001Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.16621e-05 13L1.9998 13.0001L1.99976 15.0001L-3.73125e-05 15L1.16621e-05 13Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
